export default __webpack_public_path__ + "audio/2b48ae2e0544fe58aaaad1b8d19dd6bb.mp3";